export const styles = {
  dialog: {
    '& .MuiPaper-root': {
      maxWidth: '560px',
      width: '100%',
      borderRadius: '12px',
      padding: '20px 0',
    },
    '&.success .MuiPaper-root': {
      padding: '40px',
      maxWidth: '420px',
    },
  },
  dialogTitle: {
    padding: '20px 40px',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '136%',
    color: '#23252f',
  },
  dialogContent: {
    padding: '0 !important',
  },
  dialogItems: {
    borderTop: '1px solid #f3f4f9',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 40px',
  },
  labelContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  label: {
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#131f1e',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  optional: {
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  rating: {
    gap: '7px',
    '& .MuiRating-iconActive': {
      transform: 'none',
    },
  },
  errorMessage: {
    color: 'red',
    fontFamily: 'Inter',
    fontSize: '14px',
    margin: '0 auto',
  },
  actions: {
    borderTop: '1px solid #f3f4f9',
    padding: '20px 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  btn: {
    padding: '12px 14px',
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
    textTransform: 'capitalize',
    color: '#4D6EF5',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    '&:hover': {
      backgroundColor: '#fff',
      opacity: '0.8',
    },
    '&.filled': {
      color: '#fff',
      backgroundColor: '#4D6EF5',
    },
  },
};
